import React, {useState} from 'react';
import {
   View,
   Image,
   Text,
   Dimensions,
   StyleSheet,
   Linking,
   TouchableOpacity,
   Platform,
} from 'react-native';
import {
   appBackground,
   appBackgroundWhiteBG,
   drawerListBackgroundColor,
   FONT_FAMILY_BOLD,
   FONT_FAMILY_REGULAR,
   FONT_FAMILY_SEMI_BOLD,
   gray,
   isWeb,
   PROFILE,
   white,
   TabView_HOVER_COLOR,
   DROPDOWN_HOVER_COLOR,
} from './utils';
import {useNavigation} from '@react-navigation/native';

const {width} = Dimensions.get('window');

const LogutPopup = props => {
   const navigation = useNavigation();
   const [selectedItem, setSelectedItem] = useState(null);

   const handlePress = item => {
      setSelectedItem(item);
   };
   const [isProfileHover, setProfileHover] = useState(false);
   const [isEditProfileHover, setEditProfileHover] = useState(false);
   const [isLogOutHover, setLogOuteHover] = useState(false);

   return (
      <View style={styles.container}>
         <Image
            style={[
               styles.anchorImageUpward,
               {...Platform.select({web: {width: 22, height: 15}})},
            ]}
            source={require('../assets/anchorUpward.png')}
         />
         <View style={styles.background}>
            {props.screen !== PROFILE && (
               <View>
                  <TouchableOpacity
                     onMouseEnter={() => setProfileHover(true)}
                     onMouseLeave={() => setProfileHover(false)}
                     onPress={() => {
                        handlePress('item1');
                        setTimeout(() => {
                           props.dismissPopover();
                           navigation.navigate('ProfileScreen');
                        }, 500);
                     }}>
                     <View
                        style={{
                           flexDirection: 'row',
                           alignItems: 'center',
                        }}>
                        {selectedItem === 'item1' && (
                           <Image
                              style={{width: 3.73, height: 16}}
                              source={require('../assets/blueIndicator.png')}
                           />
                        )}
                        <Text
                           style={[
                              styles.textStyle,
                              isProfileHover && {color: DROPDOWN_HOVER_COLOR},
                           ]}>
                           {'View Profile'}
                        </Text>
                     </View>
                  </TouchableOpacity>

                  <View style={styles.borderStyle} />

                  <TouchableOpacity
                     onMouseEnter={() => setEditProfileHover(true)}
                     onMouseLeave={() => setEditProfileHover(false)}
                     onPress={() => {
                        handlePress('item2');
                        setTimeout(() => {
                           props.dismissPopover();
                           navigation.navigate('EditProfileScreen');
                        }, 500);
                     }}>
                     <View
                        style={{
                           flexDirection: 'row',
                           alignItems: 'center',
                        }}>
                        {selectedItem === 'item2' && (
                           <Image
                              style={{width: 3.73, height: 16, marginTop: 15}}
                              source={require('../assets/blueIndicator.png')}
                           />
                        )}
                        <Text
                           style={[
                              styles.textStyle,
                              {marginTop: 16},
                              isEditProfileHover && {
                                 color: DROPDOWN_HOVER_COLOR,
                              },
                           ]}>
                           {'Edit Profile'}
                        </Text>
                     </View>
                  </TouchableOpacity>

                  <View style={styles.borderStyle} />
               </View>
            )}

            <TouchableOpacity
               onMouseEnter={() => setLogOuteHover(true)}
               onMouseLeave={() => setLogOuteHover(false)}
               onPress={() => {
                  handlePress('item3');
                  setTimeout(() => {
                     props.dismissPopover();
                     navigation.navigate('LogoutScreen');
                  }, 500);
               }}>
               <View style={{flexDirection: 'row'}}>
                  {selectedItem === 'item3' && (
                     <Image
                        style={{
                           width: 3.73,
                           height: 16,
                           marginTop: props.screen !== PROFILE ? 20 : 3,
                        }}
                        source={require('../assets/blueIndicator.png')}
                     />
                  )}
                  <Text
                     style={[
                        styles.textStyle,
                        isLogOutHover && {color: DROPDOWN_HOVER_COLOR},
                        {marginTop: props.screen !== PROFILE ? 16 : 0},
                     ]}>
                     {'Logout'}
                  </Text>
               </View>
            </TouchableOpacity>

            <View style={styles.borderStyle} />
         </View>
      </View>
   );
};

const styles = StyleSheet.create({
   container: {width: 200, zIndex: 1},
   anchorImage: {
      marginBottom: 0,
      justifyContent: 'center',
      alignSelf: 'center',
      tintColor: appBackgroundWhiteBG,
   },
   anchorImageUpward: {
      marginBottom: 0,
      justifyContent: 'center',
      zIndex: isWeb ? 20 : null,
      alignSelf: 'flex-end',
      marginEnd: 16,
      width: 20,
      height: 13,
      tintColor: appBackgroundWhiteBG,
   },
   background: {
      backgroundColor: appBackgroundWhiteBG,
      paddingVertical: 16,
      paddingStart: 16,
      paddingEnd: 16,
      borderTopWidth: 0,
      shadowColor: isWeb ? 'black' : null,
      shadowOffset: {width: 0, height: 1},
      shadowOpacity: isWeb ? 0.2 : null,
      shadowRadius: isWeb ? 5 : null,
      elevation: isWeb ? 5 : null,
      borderColor:
         Platform.OS === 'windows' ? 'rgba(158, 150, 150, 0.2)' : null,
      borderWidth: Platform.OS === 'windows' ? 2 : null,
      borderRadius: Platform.OS === 'windows' ? 10 : 8,
   },
   textStyle: {
      color: '#212121',
      fontSize: 16,
      fontWeight: '400',
      marginStart: 8,
      fontFamily: FONT_FAMILY_SEMI_BOLD,
   },
   borderStyle: {
      width: 150,
      height: 1,
      backgroundColor: gray,
      marginTop: 8,
   },
});

export default LogutPopup;
